import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

const PlusIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faPlus} {...rest} className={className} />;
};

export default PlusIcon;
